import { render, staticRenderFns } from "./operPreview_copy.vue?vue&type=template&id=6c5011c2&scoped=true"
import script from "./operPreview_copy.vue?vue&type=script&lang=js"
export * from "./operPreview_copy.vue?vue&type=script&lang=js"
import style0 from "./operPreview_copy.vue?vue&type=style&index=0&id=6c5011c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5011c2",
  null
  
)

export default component.exports